import { hover } from 'pobble-components/dist/jss-mixins'

export default ({ COLORS }) => ({
  applyToAll: {
    color: COLORS.BLUE.FADED,
    cursor: 'pointer',
    ...hover({
      color: COLORS.BLUE.NORMAL
    })
  }
})
